import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as customTabActions from "../../../../actions/customTabActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";

import Modal from "../../../global/generic/Modal";
import Input from "../../../global/generic/Input";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";

class EditCustomFandeckModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fandeckNameInputText: props.params.fandeck !== null ? props.params.fandeck.displayName : ""
        };
    }

    handleFandeckNameInputChange = (event) => {
        this.setState({fandeckNameInputText: event.target.value});
    };

    handleEditCustomFandeckClick = () => {
        const trimmedFandeckNameInputText = this.state.fandeckNameInputText.trim();
        if (trimmedFandeckNameInputText.length > 0) {
            if (this.props.params.fandeck !== null) {
                this.props.dispatchEditCustomFandeckAction(this.props.params.fandeck.id, trimmedFandeckNameInputText);
            } else {
                this.props.dispatchAddCustomFandeckAction(trimmedFandeckNameInputText);
            }
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseAddCustomFandeckModalAction();
    };

    getConfirmButton = () => {
        if (this.state.fandeckNameInputText.trim().length === 0) {
            return (
                <button className="btn btn-info action-button disabled">
                    <ReactSVG className="pull-left action-icon" src={imgConfirm} alt="confirm" />
                    <Translate value="general.confirm" />
                </button>
            );
        }

        return (
            <button className="btn btn-info action-button" onClick={this.handleEditCustomFandeckClick}>
                <ReactSVG className="pull-left action-icon" src={imgConfirm} alt="confirm" />
                <Translate value="general.confirm" />
            </button>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-3">
                    <Translate value="general.fandeckName" />:
                </div>
                <Input
                    className="primary-input col-9"
                    value={this.state.fandeckNameInputText}
                    onChange={this.handleFandeckNameInputChange}
                />
            </React.Fragment>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    onClick={this.handleEditCustomFandeckClick}
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                    disabled={this.state.fandeckNameInputText.trim().length === 0}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                className="custom-formula"
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("general.customFandeck"), "color-green")}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    width: "40%"
                }}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAddCustomFandeckAction: (fandeckName) => {
            dispatch(customTabActions.addCustomFandeck(fandeckName));
        },
        dispatchEditCustomFandeckAction: (id, name) => {
            dispatch(customTabActions.editCustomFandeck(id, name));
        },
        dispatchCloseAddCustomFandeckModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_CUSTOM_FANDECK_MODAL));
        }
    };
};

export default EditCustomFandeckModal = connect(mapStoreToProps, mapDispatchToProps)(EditCustomFandeckModal);
